import { render } from "./MatchBetOutcome.vue?vue&type=template&id=0d91a3f7"
import script from "./MatchBetOutcome.vue?vue&type=script&lang=js"
export * from "./MatchBetOutcome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__